"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCustoTree = void 0;

var components_1 = require("../components");

var texts_1 = require("../texts");

var hook_1 = require("../hook");

var react_flexible_contexts_1 = require("react-flexible-contexts");

var interfaces_1 = require("../../interfaces");

var data_1 = require("../data");

var prop_1 = require("../../utils/prop");

var components_2 = require("./components");

var texts_2 = require("./texts");

var data_2 = require("./data");

var hook_2 = require("./hook");

var utils_1 = require("../../utils");

var getArgs = function getArgs(args) {
  if (args[0] instanceof react_flexible_contexts_1.StackedContext) {
    return {
      obj: args[0].context.defaultValueGetter().value,
      useSelector: args[0].context.useSelector,
      options: args[1] || {}
    };
  }

  return {
    obj: args[0],
    useSelector: args[1],
    options: args[2] || {}
  };
};

function buildCustoTree() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  var _a = getArgs(args),
      obj = _a.obj,
      useSelector = _a.useSelector,
      options = _a.options;

  var defaultValuesByTypes = options.defaultValuesByTypes || {};
  var prefixes = options.prefixes || ["value"];

  var helper = function helper(prefixes, obj, defaultValue, final) {
    if (final === void 0) {
      final = {};
    }

    var _loop_1 = function _loop_1(key) {
      var val = obj[key];
      var defVal = defaultValue ? defaultValue[key] : undefined;

      var getVal = function getVal() {
        return useSelector(function (x) {
          return prop_1.untypedGetProp.apply(void 0, __spread([x], prefixes, [key]));
        }, []);
      };

      var path = __spread(prefixes, [key]).join(".");

      if (val === interfaces_1.CustoType.component || val instanceof components_1.CustoComponent || val instanceof hook_1.CustoHook && val.type === interfaces_1.CustoType.component) {
        // Component
        final[key] = components_2.buildCustoComponent(getVal, path, defVal || defaultValuesByTypes[interfaces_1.CustoType.component]);
      } else if (val === interfaces_1.CustoType.text || val instanceof texts_1.CustoText || val instanceof hook_1.CustoHook && val.type === interfaces_1.CustoType.text) {
        // Text
        final[key] = texts_2.buildCustoText(getVal, options.getTextTransformationHook, path, defVal || defaultValuesByTypes[interfaces_1.CustoType.text]);
      } else if (val === interfaces_1.CustoType.data || val instanceof data_1.CustoData || val instanceof hook_1.CustoHook && val.type === interfaces_1.CustoType.data) {
        // Data
        final[key] = data_2.buildCustoData(getVal, path, defVal || defaultValuesByTypes[interfaces_1.CustoType.data]);
      } else if (val === interfaces_1.CustoType.hook || val instanceof hook_1.CustoHook && val.type === interfaces_1.CustoType.hook) {
        // Hook
        final[key] = hook_2.buildCustoHook(getVal, path, defVal || defaultValuesByTypes[interfaces_1.CustoType.hook]);
      } else if (utils_1.isCustoClass(val)) {//
      } else {
        final[key] = {};
        helper(__spread(prefixes, [key]), obj[key], defaultValue ? defaultValue[key] : undefined, final[key]);
      }
    };

    for (var key in obj) {
      _loop_1(key);
    }

    return final;
  };

  var result = helper(prefixes || [], obj, options.defaultValue);
  return result;
}

exports.buildCustoTree = buildCustoTree;